<template>
  <div>
    <div class="account-wrap">
      <h2 class="account-title">入住登记信息</h2>
      <cell-box :column="1" class="account-info">
        <cell-item label="订单号：" :value="info.OrderNo" />
        <cell-item label="联系人：" :value="info.Contact" />
        <cell-item label="联系电话：" :value="info.Phone" />
        <cell-item label="入住日期：" :value="info.CheckInDate" />
        <cell-item label="离店日期：" :value="info.CheckOutDate" />

        <cell-item label="渠道：" :value="info.ChannelName" />
        <cell-item label="协议客户：" :value="info.CustomerName" />
        <cell-item label="会员卡号：" :value="info.MemberCardNo" />
        <cell-item label="总晚数：" :value="info.TotalNights" />
        <cell-item label="总房费：">
          <span slot="value" style="color:#f00">
            &yen;{{ info.RoomRents }}
          </span>
        </cell-item>
        <cell-item label="备注：" :value="info.Remark" />
      </cell-box>
      <table class="account-table">
        <tr>
          <th>房号</th>
          <th>房价</th>
          <th>晚数</th>
        </tr>
        <tr v-for="(item, index) in info.Rooms" :key="index">
          <td>{{ item.RoomNo }}</td>
          <td>{{ item.RoomPrice }}</td>
          <td>{{ item.Nights }}</td>
        </tr>
      </table>

      <div class="sign-name">
        <img :src="'data:image/jpeg;base64,' + info.Base64Image" alt="" />
      </div>
    </div>
    <van-goods-action>
      <van-button type="info" block @click="toSign">
        {{ info.Base64Image ? "重新签名" : "签名" }}
      </van-button>
    </van-goods-action>
  </div>
</template>

<script>
import "./sign.less";
import { getRegisterInfo } from "@/api/sign.js";
import { CellBox, CellItem } from "@/components/cell";
import { Button, Panel, GoodsAction, Row, Col } from "vant";
export default {
  components: {
    [Button.name]: Button,
    [Panel.name]: Panel,
    [Row.name]: Row,
    [Col.name]: Col,
    [GoodsAction.name]: GoodsAction,
    CellBox,
    CellItem,
  },
  data() {
    return {
      id: "",
      info: {},
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getInfo();
  },
  methods: {
    getInfo() {
      getRegisterInfo({ Id: this.id }).then(res => {
        this.info = res.Data;
      });
    },
    toSign() {
      this.$router.push({
        name: "signPanel",
        query: {
          orderId: this.id,
          type: 0,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
